//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import isMobile from "~/mixins/isMobile.js";

export default {
  mixins: [isMobile],
  props: {
    data: {
      required: true,
    },
    links: {
      required: true,
    },
    cta: {
      required: true,
    },
    customText: {
      required: false,
    },
    is_previewable: {
      required: false,
    },
    preview: {
      required: false,
    },
  },
  data() {
    return {
      isDoubleQuote: false,
      localPreview: "",
      isFullPreview: false,
    };
  },
  created() {
    if (!process.server) this.localPreview = this.decodeHtml(this.preview);
  },
  computed: {
    mainDescription() {
      let match = this.data.table.subtitle.match(/[^.]+\./);
      return match ? match[0] : "";
    },

    secondDescription() {
      let description = this.data.table.subtitle
        .replace(this.mainDescription, "")
        .trim();
      if (description)
        if (description[0] !== '"') return description;
        else {
          this.isDoubleQuote = true;
          return description.substring(1);
        }
    },

    productDescription() {
      return this.data.table.subtitle.split(/.(.+)/s);
    },
    product() {
      return this.$route.params.product_slug;
    },
    showCustomIcon() {
      if (this.product === "articles-of-organization") return true;
      else if (this.product === "certificate-of-good-standing") return true;
      else if (this.product === "employer-identification-number") return true;
      else if (this.product === "foreign-entity") return true;
      else if (this.product === "articles-of-amendment") return true;
      else if (this.product === "certified-copy") return true;
      else if (this.product === "joint-revocable-living-trust") return true;
      else if (this.product === "revocable-living-trust") return true;
      else if (this.product === "property-purchase-agreement") return true;
      else if (this.product === "property-deed") return true;
      else if (this.product === "special-warranty-deed") return true;
      else if (this.product === "purchase-agreement") return true;
      else if (this.product === "pour-over-will") return true;
      else if (this.product === "bill-of-sale") return true;
      else if (this.product === "employment-contract") return true;
      else if (this.product === "employment-offer-letter") return true;
      else if (this.product === "medical-power-of-attorney") return true;
      else if (this.product === "living-will") return true;
      else if (this.product === "residential-rental-agreement") return true;
    },
  },
  methods: {
    decodeHtml(html) {
      if (document) {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
      }
    },
    handlePreview() {
      if (this.isFullPreview) this.isFullPreview = false;
      else this.isFullPreview = true;
    },
  },
};
